import { useFlags } from 'launchdarkly-react-client-sdk';
import { PermissionKey } from '../../../services/PermissionAndRolesKeys';
import { PermissionService } from '../../../services/PermissionService';
import { MaggieFeatureFlags } from '../../../util/feature-flags';

/**
 * Single gating site for the Field Manager: the flag turns the module on and
 * the customer-success permission scopes who sees it. Shared by the admin-panel
 * landing and the KPI Groups back chevron so the condition cannot drift
 * between them.
 */
export function useFieldManagerAvailable(): boolean {
  const { showFieldsManager } = useFlags<MaggieFeatureFlags>();
  return (
    Boolean(showFieldsManager) && PermissionService.get().hasPermission(PermissionKey.customerSuccessAll)
  );
}
